export const technologiesBadgeColor = {
	'Node.js': { backgroundColor: '#339933', color: 'white' },
	JavaScript: { backgroundColor: '#F7DF1E', color: 'black' },
	React: { backgroundColor: '#61DAFB', color: 'black' },
	HTML: { backgroundColor: '#E34F26', color: 'white' },
	CSS: { backgroundColor: '#1572B6', color: 'white' },
	'Express.js': { backgroundColor: 'white', color: 'black' },
	Bootstrap: { backgroundColor: '#7952B3', color: 'white' },
	'Next.js': { backgroundColor: '#000000', color: 'white' },
	Typescript: { backgroundColor: '#3178C6', color: 'white' },
	'Ethers.js': { backgroundColor: 'white', color: '#24339B' },
	Solidity: { backgroundColor: '#363636', color: 'white' },
	Hardhat: { backgroundColor: '#FFF100', color: 'black' },
	Ethereum: { backgroundColor: '#363636', color: 'white' },
	PHP: { backgroundColor: '#777BB4', color: 'white' },
	MySQL: { backgroundColor: '#4479A1', color: 'white' },
	jQuery: { backgroundColor: '#0769AD', color: 'white' },
	'Material UI': { backgroundColor: '#0081CB', color: 'white' },
	'Tailwind CSS': { backgroundColor: '#38B2AC', color: 'white' },
	'Socket.IO': { backgroundColor: '#010101', color: 'white' },
	MongoDB: { backgroundColor: '#47A248', color: 'white' },
	PostgreSQL: { backgroundColor: '#336791', color: 'white' },
	Redis: { backgroundColor: '#DC382D', color: 'white' },
	JWT: { backgroundColor: '#000000', color: 'white' },
	Chai: { backgroundColor: '#F6ECD9', color: '#D33A31' },
	Mocha: { backgroundColor: '#8D6748', color: 'white' },
	OpenZeppelin: { backgroundColor: 'white', color: '#64B0FB' },
	IPFS: { backgroundColor: '#449294', color: 'white' },
	MetaMask: { backgroundColor: '#E2761B', color: 'white' },
	Electron: { backgroundColor: '#47848F', color: 'white' },
	GraphQL: { backgroundColor: '#E10098', color: 'white' },
	MQTT: { backgroundColor: '#D91E18', color: 'white' },
	WebSockets: { backgroundColor: '#000000', color: 'white' },
	Prisma: { backgroundColor: '#2D3748', color: 'white' },
	SQLite: { backgroundColor: '#003B57', color: 'white' },
	Leaflet: { backgroundColor: '#199900', color: 'white' },
};
